import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { getProject } from "../../../../../../Store/Store/Project/Project";

const ChallanDetails = ({
    challanData,
    error,
    handleChange,
    cityList,
    stateList,
    cityList2,
    stateList2,
}) => {

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getProject());
    }, []);

    const projectData =
        useSelector((state) => state.getProject?.user?.data) || [];

    return (
        <div className="row">
            {/* ================= Basic Challan Details ================= */}

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Date <span className="text-danger">*</span></label>
                    <input
                        className="form-control"
                        type="date"
                        value={challanData.date}
                        onChange={(e) =>
                            handleChange(null, "date", e.target.value)
                        }
                    />
                </div>
            </div>

            <div className="col-12 col-md-4 col-xl-4">
                <div className="input-block local-forms custom-select-wpr">
                    <label>
                        Project <span className="login-danger">*</span>
                    </label>
                    <Dropdown
                        value={challanData.project_id}
                        options={projectData?.map((e) => ({
                            label: e.project_no ? `${e.name} (${e.project_no})` : e.name,
                            value: e._id,
                        }))}
                        onChange={(e) =>
                            handleChange(null, "project_id", e.value)
                        }
                        placeholder="Select Project"
                        filter
                        className="w-100"
                        disabled={challanData?._id}
                    />
                    <div className="error">{error?.project_id}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Project No</label>
                    <input
                        className="form-control"
                        type="text"
                        value={challanData.project_no}
                        onChange={(e) =>
                            handleChange(null, "project_no", e.target.value)
                        }
                    />
                </div>
            </div>

            <div className="col-12">
                <div className="input-block local-forms">
                    <label>Description</label>
                    <textarea
                        className="form-control"
                        placeholder="Enter description"
                        value={challanData.description}
                        onChange={(e) =>
                            handleChange(null, "description", e.target.value)
                        }
                    />
                </div>
            </div>

            {/* ================= Bill To ================= */}
            <div className="col-12">
                <h4 className="mb-3">Bill To</h4>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Name
                        {/* <span className="text-danger">*</span> */}
                    </label>
                    <input
                        className="form-control"
                        type="text"
                        value={challanData.bill_to.name}
                        onChange={(e) =>
                            handleChange("bill_to", "name", e.target.value)
                        }
                    />
                    <div className="error">{error?.bill_to?.name}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Address <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        value={challanData.bill_to.address}
                        onChange={(e) =>
                            handleChange("bill_to", "address", e.target.value)
                        }
                    />
                    <div className="error">{error?.bill_to?.address}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Address Line 2</label>
                    <input
                        type="text"
                        className="form-control"
                        value={challanData.bill_to.addressOne}
                        onChange={(e) =>
                            handleChange("bill_to", "addressOne", e.target.value)
                        }
                    />
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>State <span className="text-danger">*</span></label>
                    <select
                        className="form-select"
                        value={challanData.bill_to.state}
                        onChange={(e) =>
                            handleChange("bill_to", "state", e.target.value)
                        }
                    >
                        <option value="">Select State</option>
                        {stateList?.map((state) => (
                            <option key={state.isoCode} value={state.name}>
                                {state.name}
                            </option>
                        ))}
                    </select>
                    <div className="error">{error?.bill_to?.state}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>City <span className="text-danger">*</span></label>
                    <select
                        className="form-select"
                        value={challanData.bill_to.city}
                        onChange={(e) =>
                            handleChange("bill_to", "city", e.target.value)
                        }
                    >
                        <option value="">Select City</option>
                        {cityList?.map((city) => (
                            <option key={city.name} value={city.name}>
                                {city.name}
                            </option>
                        ))}
                    </select>
                    <div className="error">{error?.bill_to?.city}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Pincode <span className="text-danger">*</span></label>
                    <input
                        className="form-control"
                        type="number"
                        value={challanData.bill_to.pincode}
                        onChange={(e) =>
                            handleChange("bill_to", "pincode", e.target.value)
                        }
                    />
                    <div className="error">{error?.bill_to?.pincode}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>GST No</label>
                    <input
                        className="form-control"
                        type="text"
                        value={challanData.bill_to.gst_no}
                        onChange={(e) =>
                            handleChange("bill_to", "gst_no", e.target.value)
                        }
                    />
                </div>
            </div>

            {/* ================= Ship To ================= */}
            <div className="col-12">
                <h4 className="mb-3">Ship To</h4>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Name
                        {/* <span className="text-danger">*</span> */}
                    </label>
                    <input
                        className="form-control"
                        type="text"
                        value={challanData.ship_to.name}
                        onChange={(e) =>
                            handleChange("ship_to", "name", e.target.value)
                        }
                    />
                    <div className="error">{error?.ship_to?.name}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Address <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        value={challanData.ship_to.address}
                        onChange={(e) =>
                            handleChange("ship_to", "address", e.target.value)
                        }
                    />
                    <div className="error">{error?.ship_to?.address}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Address Line 2</label>
                    <input
                        type="text"
                        className="form-control"
                        value={challanData.ship_to.addressOne}
                        onChange={(e) =>
                            handleChange("ship_to", "addressOne", e.target.value)
                        }
                    />
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>State <span className="text-danger">*</span></label>
                    <select
                        className="form-select"
                        value={challanData.ship_to.state}
                        onChange={(e) =>
                            handleChange("ship_to", "state", e.target.value)
                        }
                    >
                        <option value="">Select State</option>
                        {stateList2?.map((state) => (
                            <option key={state.isoCode} value={state.name}>
                                {state.name}
                            </option>
                        ))}
                    </select>
                    <div className="error">{error?.ship_to?.state}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>City <span className="text-danger">*</span></label>
                    <select
                        className="form-select"
                        value={challanData.ship_to.city}
                        onChange={(e) =>
                            handleChange("ship_to", "city", e.target.value)
                        }
                    >
                        <option value="">Select City</option>
                        {cityList2?.map((city) => (
                            <option key={city.name} value={city.name}>
                                {city.name}
                            </option>
                        ))}
                    </select>
                    <div className="error">{error?.ship_to?.city}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Pincode <span className="text-danger">*</span></label>
                    <input
                        className="form-control"
                        type="number"
                        value={challanData.ship_to.pincode}
                        onChange={(e) =>
                            handleChange("ship_to", "pincode", e.target.value)
                        }
                    />
                    <div className="error">{error?.ship_to?.pincode}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>GST No</label>
                    <input
                        className="form-control"
                        type="text"
                        value={challanData.ship_to.gst_no}
                        onChange={(e) =>
                            handleChange("ship_to", "gst_no", e.target.value)
                        }
                    />
                </div>
            </div>


            {/* ================= Transportation ================= */}
            <div className="col-12">
                <h4 className="mb-3">Transportation Details</h4>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Date <span className="text-danger">*</span></label>
                    <input
                        className="form-control"
                        type="date"
                        value={challanData.transportation_details.date}
                        onChange={(e) =>
                            handleChange(
                                "transportation_details",
                                "date",
                                e.target.value
                            )
                        }
                    />
                </div>
                <div className="error">{error?.transportation_details?.date}</div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Doc No <span className="text-danger">*</span></label>
                    <input
                        className="form-control"
                        type="text"
                        value={challanData.transportation_details.doc_no}
                        onChange={(e) =>
                            handleChange(
                                "transportation_details",
                                "doc_no",
                                e.target.value
                            )
                        }
                    />
                    <div className="error">{error?.transportation_details?.doc_no}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Delivery Terms <span className="text-danger">*</span></label>
                    <input
                        className="form-control"
                        type="text"
                        value={challanData.transportation_details.delivery_terms}
                        onChange={(e) =>
                            handleChange(
                                "transportation_details",
                                "delivery_terms",
                                e.target.value
                            )
                        }
                    />
                    <div className="error">{error?.transportation_details?.delivery_terms}</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Dispatch Through</label>
                    <input
                        className="form-control"
                        type="text"
                        value={challanData.transportation_details.dispatch_through}
                        onChange={(e) =>
                            handleChange(
                                "transportation_details",
                                "dispatch_through",
                                e.target.value
                            )
                        }
                    />
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <div className="input-block local-forms">
                    <label>Other Reference</label>
                    <input
                        className="form-control"
                        type="text"
                        value={challanData.transportation_details.other_ref}
                        onChange={(e) =>
                            handleChange(
                                "transportation_details",
                                "other_ref",
                                e.target.value
                            )
                        }
                    />
                </div>
            </div>

            {/* ================= Delivery & Received ================= */}
            <div className="col-12">
                <h4 className="mb-3">Delivery By</h4>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <input
                    className="form-control"
                    placeholder="Name"
                    value={challanData.delivery_by.name}
                    onChange={(e) =>
                        handleChange("delivery_by", "name", e.target.value)
                    }
                />
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <input
                    className="form-control"
                    placeholder="Comment"
                    value={challanData.delivery_by.comment}
                    onChange={(e) =>
                        handleChange("delivery_by", "comment", e.target.value)
                    }
                />
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <input
                    className="form-control"
                    type="date"
                    value={challanData.delivery_by.date}
                    onChange={(e) =>
                        handleChange("delivery_by", "date", e.target.value)
                    }
                />
            </div>

            <div className="col-12 mt-3">
                <h4 >Received By</h4>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <input
                    className="form-control"
                    placeholder="Name"
                    value={challanData.received_by.name}
                    onChange={(e) =>
                        handleChange("received_by", "name", e.target.value)
                    }
                />
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <input
                    className="form-control"
                    placeholder="Comment"
                    value={challanData.received_by.comment}
                    onChange={(e) =>
                        handleChange("received_by", "comment", e.target.value)
                    }
                />
            </div>

            <div className="col-12 col-md-6 col-xl-4">
                <input
                    className="form-control"
                    type="date"
                    value={challanData.received_by.date}
                    onChange={(e) =>
                        handleChange("received_by", "date", e.target.value)
                    }
                />
            </div>

        </div>
    );
};

export default ChallanDetails;
